import { render, staticRenderFns } from "./GetAllCourseTypes.vue?vue&type=template&id=26b8cc98"
import script from "./GetAllCourseTypes.vue?vue&type=script&lang=js"
export * from "./GetAllCourseTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports